export const wrapStatusFinancing = (status, content) => {
  switch (status) {
    case "pending":
      return "alert alert-primary";

    case "in_progress":
      return "alert alert-info";
    case "accpeted":
      return "alert alert-success";

    case "rejected":
      return "alert alert-danger";

    default:
      return "alert alert-warning";
  }
};
